import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Listens for push notification tap events and navigates to the route
 * specified in the notification payload.
 * 
 * The 'push-notification-action' event is dispatched by PushNotificationService.js
 * when the user taps on a notification.
 */
const PushNotificationHandler = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handler = (e) => {
            const { route } = e.detail || {};
            if (route) {
                console.log('[Push] Navigating to:', route);
                navigate(route);
            }
        };

        window.addEventListener('push-notification-action', handler);
        return () => window.removeEventListener('push-notification-action', handler);
    }, [navigate]);

    return null;
};

export default PushNotificationHandler;
